import {
    createRegisterableComponentWithData,
    ElectionDataLoader,
} from '@news-mono/web-common'
import React from 'react'
import { TheSeatsWidget } from './TheSeatsWidget'

type SeatWidgetRouteProps = {
    electoratePageUrl: string
    seatDisplayCount?: number
}
export const SeatWidgetRegistration = createRegisterableComponentWithData(
    'election-seat-widget',
    ElectionDataLoader,
    (props: SeatWidgetRouteProps, data, services) => {
        return (
            <TheSeatsWidget
                data={data}
                onEvent={services.onEvent}
                electoratePageUrl={props.electoratePageUrl}
                seatDisplayCount={props.seatDisplayCount}
            />
        )
    },
)
